/**
 * House of Places — "Recently viewed" band on the product page.
 *
 * Records the product on screen, then draws it (first, ringed) and up to
 * `data-limit` minus one of the others the shopper opened before, newest
 * first, from /products/<handle>.js — Drool's row includes the poster on
 * screen too, so the row is never empty. The history lives only in this
 * browser; storage that throws (private mode, blocked site data) still
 * shows the current poster.
 */
(function () {
  var root = document.querySelector('[data-hop-recently-viewed]');
  if (!root) return;

  var KEY = 'hop-recently-viewed';
  var MAX = 20;
  var current = root.getAttribute('data-current');
  var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;
  var list = root.querySelector('[data-hop-rv-list]');

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(v) {
    try {
      localStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) {
      /* storage unavailable — nothing to remember */
    }
  }

  var history = read();
  var others = history.filter(function (h) {
    return h !== current;
  });
  // Record this product first, so the band on the next page already has it.
  write([current].concat(others).slice(0, MAX));

  var money;
  try {
    money = new Intl.NumberFormat(root.getAttribute('data-locale') || 'en', {
      style: 'currency',
      currency: root.getAttribute('data-currency') || 'USD',
    });
  } catch (e) {
    money = { format: function (n) { return n.toFixed(2); } };
  }
  var fromLabel = root.getAttribute('data-from-label') || '%PRICE%';

  function card(p) {
    var li = document.createElement('li');
    li.className = 'hop-rv__item' + (p.handle === current ? ' is-current' : '');
    var a = document.createElement('a');
    a.className = 'hop-rv__link';
    a.href = p.url;
    if (p.handle === current) a.setAttribute('aria-current', 'page');
    var media = document.createElement('div');
    media.className = 'hop-rv__media';
    if (p.featured_image) {
      var img = document.createElement('img');
      // Shopify CDN sizing: ask for a small rendition, not the original.
      var src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
      img.src = src.indexOf('//') === 0 ? 'https:' + src : src;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 300;
      img.height = 375;
      media.appendChild(img);
    }
    var tag = document.createElement('span');
    tag.className = 'hop-rv__tag';
    var title = document.createElement('span');
    title.className = 'hop-rv__title';
    title.textContent = p.title.split(' – ')[0].split(' — ')[0];
    var price = document.createElement('span');
    price.className = 'hop-rv__price';
    var amount = money.format(p.price_min / 100);
    price.textContent = p.price_varies ? fromLabel.replace('%PRICE%', amount) : amount;
    tag.appendChild(title);
    tag.appendChild(price);
    a.appendChild(media);
    a.appendChild(tag);
    li.appendChild(a);
    return li;
  }

  var wanted = [current].concat(others).slice(0, limit);
  Promise.all(
    wanted.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    })
  ).then(function (products) {
    var found = products.filter(function (p) {
      return p && p.available !== undefined;
    });
    // Products that no longer exist drop out of the stored history too.
    if (found.length < wanted.length) {
      var alive = found.map(function (p) {
        return p.handle;
      });
      write(
        read().filter(function (h) {
          return h === current || wanted.indexOf(h) === -1 || alive.indexOf(h) !== -1;
        })
      );
    }
    if (!found.length) return;
    found.forEach(function (p) {
      list.appendChild(card(p));
    });
    root.hidden = false;
  });
})();
